exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header[data-v-87dc9032] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  text-align: center;\n  padding: 12px 24px;\n  border-bottom: 2px solid #b1b4cd;\n}\n.header > div[data-v-87dc9032] {\n    flex: 1;\n}\n.row[data-v-87dc9032] {\n  display: flex;\n  font-weight: 400;\n  flex-direction: row;\n  justify-content: space-between;\n  text-align: center;\n  padding: 6px 24px;\n  border-bottom: 1px dotted #b1b4cd;\n}\n.row > div[data-v-87dc9032] {\n    flex: 1;\n}\n.row[data-v-87dc9032]:hover {\n  background: #f2f2f2;\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-87dc9032","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/usr/src/app/src/assets/_include-media.scss","/usr/src/app/src/assets/palette.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/aGrid.vue
// module id = TGvM
// module chunks = 1